export default __webpack_public_path__ + "static/gb-eng-66465e3823b21cd981e3a60381750f39.svg";